import React from 'react';
import '../../styles/Perfil.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faKey, faLock, faShieldHalved } from '@fortawesome/free-solid-svg-icons';

const Seguranca = () => {
    return (
        <div className='container-direito-interno'>
            <div className='perfil-section-header'>
                <span>Acesso</span>
                <h1>Segurança</h1>
            </div>

            <div className='perfil-card container-opcoes'>
                <div className='container-opcao'>
                    <div className='perfil-info-icon'>
                        <FontAwesomeIcon icon={faLock} />
                    </div>
                    <div className='perfil-info-content'>
                        <span>Status</span>
                        <strong>Conta autenticada</strong>
                    </div>
                    <span className='perfil-status-badge'>Ativo</span>
                </div>

                <div className='container-opcao'>
                    <div className='perfil-info-icon'>
                        <FontAwesomeIcon icon={faKey} />
                    </div>
                    <div className='perfil-info-content'>
                        <span>Credenciais</span>
                        <strong>Senha gerenciada pelo login</strong>
                    </div>
                </div>

                <div className='container-opcao'>
                    <div className='perfil-info-icon'>
                        <FontAwesomeIcon icon={faShieldHalved} />
                    </div>
                    <div className='perfil-info-content'>
                        <span>Proteção</span>
                        <strong>Sessão protegida</strong>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Seguranca;
